import { render, staticRenderFns } from "./MLHG.vue?vue&type=template&id=5d90d62c&scoped=true"
import script from "./MLHG.vue?vue&type=script&lang=js"
export * from "./MLHG.vue?vue&type=script&lang=js"
import style0 from "./MLHG.vue?vue&type=style&index=0&id=5d90d62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90d62c",
  null
  
)

export default component.exports